import pluralize from 'pluralize';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Checkbox, Confirmation, HelpTooltip } from '~/components';

const Body = styled.div`
  display: grid;
  row-gap: 1rem;
`;

const List = styled.ul`
  max-height: 12rem;
  overflow-y: auto;

  li {
    list-style: initial;
    list-style-position: inside;
    padding-left: 0.6rem;
  }
`;

const Option = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
`;

function ShiftBlockedTasksConfirmation({ taskName, blockedTasks, resolve }) {
  const [shiftSuccessors, setShiftSuccessors] = useState(true);

  return (
    <Confirmation resolve={(confirm) => resolve(confirm ? { shiftSuccessors } : null)}>
      <Body>
        <div>
          This {taskName} task is blocking {pluralize('task', blockedTasks.length, true)}:
        </div>
        <List>
          {blockedTasks.map((task) => (
            <li key={task.id}>{task.name}</li>
          ))}
        </List>
        <Option>
          <Checkbox
            checked={shiftSuccessors}
            onChange={(event) => setShiftSuccessors(event.target.checked)}
            label="Shift dates on blocked tasks"
          />
          <HelpTooltip
            message={`If unchecked, only ${taskName}'s dates will be updated. Blocked tasks will keep their current dates.`}
          />
        </Option>
      </Body>
    </Confirmation>
  );
}

export default ShiftBlockedTasksConfirmation;
